module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av237-7f8e2572865b3602ee9702c7795321d1.jpg";